import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Youtube, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <span className="font-heading text-2xl font-semibold text-white">WCareers</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Empowering individuals to achieve their professional potential through world-class career guidance and education.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-testid="social-youtube">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-medium mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/courses" className="text-slate-400 hover:text-white text-sm transition-colors">
                  All Courses
                </Link>
              </li>
              <li>
                <Link to="/counseling" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Career Counseling
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Blog & Resources
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-lg font-medium mb-6">Categories</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/courses?category=Technology" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Technology
                </Link>
              </li>
              <li>
                <Link to="/courses?category=Business" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Business
                </Link>
              </li>
              <li>
                <Link to="/courses?category=Marketing" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Marketing
                </Link>
              </li>
              <li>
                <Link to="/courses?category=Design" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Design
                </Link>
              </li>
              <li>
                <Link to="/courses?category=Finance" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Finance
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-medium mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-lime-500 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">
                  123 Career Street, Suite 100<br />
                  New York, NY 10001
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-lime-500 flex-shrink-0" />
                <a href="tel:+1234567890" className="text-slate-400 hover:text-white text-sm transition-colors">
                  +1 (234) 567-890
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-lime-500 flex-shrink-0" />
                <a href="mailto:hello@wcareers.com" className="text-slate-400 hover:text-white text-sm transition-colors">
                  hello@wcareers.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {currentYear} WCareers. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
